import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import FluidImage from 'components/FluidImage';
import Icon from 'components/Icon';

import OnScreen from 'components/OnScreen';

import css from './ProjectCardSlider.module.scss';

class ProjectCardSlider extends React.PureComponent {
    static propTypes = {
        image: PropTypes.string,
        compact: PropTypes.bool.isRequired,
        projectEnd: PropTypes.string,
        projectEndFormatted: PropTypes.string,
        projectStart: PropTypes.string,
        projectStartFormatted: PropTypes.string,
        features: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string.isRequired,
            subtitle: PropTypes.string.isRequired,
        })),
        projectStatusLabel: PropTypes.string.isRequired,
        onScreen: PropTypes.bool,
    }

    static defaultProps = {
        compact: false,
    }

    state = {
        activeSlide: 0
    }

    _handleSlideClick = e => {
        const { activeSlide } = this.state;
        const { direction } = e.currentTarget.dataset;

        e.stopPropagation();
        e.preventDefault();

        if(direction === 'prev') {
            const prevSlide = activeSlide - 1;
            return this.setState({
                activeSlide: prevSlide < 0 ? 2 : prevSlide // -1 > 2
            });
        } else if (direction === 'next') {
            const nextSlide = activeSlide + 1;
            return this.setState({
                activeSlide: nextSlide > 2 ? 0 : nextSlide // 3 > 0
            });
        }
    }

    _calculateTimeline() {
        const { projectStart, projectEnd } = this.props;

        if(!projectStart || !projectEnd) return {};

        const now = Date.now();
        const start = Date.parse(projectStart);
        const end = Date.parse(projectEnd);

        const duration = end - start;
        const progress = ((now - start) / duration) * 100;

        const past = progress <= 100 ? progress : 100;

        return {
            past,
            future: 100 - past
        };
    }

    render() {
        const {
            compact,
            image,
            projectEndFormatted,
            projectStartFormatted,
            features,
            projectStatusLabel,
            onScreen,
        } = this.props;

        const {
            activeSlide
        } = this.state;

        const timeline = this._calculateTimeline();

        const feature = features && features[0];

        return (
            <nav className={cn(css.slide, {
                [css.compact]: compact,
                [css.featureActive]: activeSlide === 2
            })}>
                <ul>
                    <li style={{ display: activeSlide!==0 ? 'none' : null }}>
                        <FluidImage
                            className={css.image}
                            image={image}
                            visible={onScreen}
                        />
                    </li>
                    <li className={cn(css.timeline, "timeline-block")} style={{ display: activeSlide!==1 ? 'none' : null }}>
                        <header>{projectStatusLabel}</header>
                        <div className="timeline">
                            <ul className="past" style={{width: timeline.past+"%"}} />
                            <div className="present">
                                <ul className="dot">
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                            </div>
                            <ul className="future" style={{width: timeline.future+"%"}} />
                        </div>
                        <ul>
                            <li>{projectStartFormatted}</li>
                            <li>{projectEndFormatted}</li>
                        </ul>
                    </li>
                    <li className={css.feature} style={{ display: activeSlide!==2 ? 'none' : null }}>
                        {feature && [
                            <h3 key="title">{feature.title}</h3>,
                            <span key="subtitle">{feature.subtitle}</span>
                        ]}
                    </li>
                </ul>
                <button
                    className={css.prev}
                    data-direction="prev"
                    onClick={this._handleSlideClick}
                ><Icon icon="arrow-grey-light-left" /></button>
                <button
                    className={css.next}
                    data-direction="next"
                    onClick={this._handleSlideClick}
                ><Icon icon="arrow-grey-light-right" /></button>
            </nav>
        );
    }
}

export default OnScreen(ProjectCardSlider);



// WEBPACK FOOTER //
// ./src/components/ProjectCardSlider/ProjectCardSlider.jsx